<template>
	<div class="header">
		<div class="right">
			<el-popover placement="bottom" :width="620" trigger="click" popper-class="popper-user-box">
				<template #reference>
					<div class="author">
						<i class="icon el-icon-s-custom" />
						<el-icon><User/></el-icon>
						{{ user && user.username || '' }}{{ `【${user.statusName}】`}}{{ user && getTimeZoneString(user.time_zone_offset) || '时区错误' }}
						<i class="el-icon-caret-bottom" />
					</div>
				</template>
				<div class="nickname">
					<p>登录账号：{{ user && user.username || '' }}</p>
					<el-tag size="small" effect="dark" class="logout" @click="logout">退出</el-tag>
					<p>本地时区：{{ getTimeZoneString((new Date()).getTimezoneOffset()) }}</p>
					<p>服务时区：{{ user && getTimeZoneString(user.time_zone_offset) || '' }}</p>
					<p>时间使用【服务时区】</p>
				</div>
			</el-popover>
		</div>
	</div>
</template>

<script>
import {user} from '@/utils/index'
import axios from '@/utils/axios'

export default {
	name: 'home-header',
	data() {
		return {user}
	},
	methods: {
		logout() {
			user.saveToken('', axios);
			location.reload();
		},
		getTimeZoneString(time_zone_offset) {
			if (!time_zone_offset) return '0时区';
			else if (time_zone_offset < 0) return `东${-Math.floor(time_zone_offset / 60)}区`;
			else return `西${Math.floor(time_zone_offset / 60)}区`;
		}
	}
}
</script>

<style scoped>
.header {
	height: 50px;
	border-bottom: 1px solid #e9e9e9;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 20px;
}
.el-icon-back {
	border: 1px solid #e9e9e9;
	padding: 4px;
	border-radius: 50px;
	margin-right: 10px;
}
.right > div > .icon{
	font-size: 18px;
	margin-right: 6px;
}
.author {
	margin-left: 10px;
	cursor: pointer;
}
</style>
<style>
.popper-user-box {
    background-size: cover!important;
    border-radius: 0!important;
}
.popper-user-box .nickname {
    position: relative;
    color: #000000;
}
.popper-user-box .nickname .logout {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
}
</style>